/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Save_And_Next_ButtonInputs */

const en_register_onboarding_personal_info_save_and_next_button = /** @type {(inputs: Register_Onboarding_Personal_Info_Save_And_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save details & Next`)
};

const de_register_onboarding_personal_info_save_and_next_button = /** @type {(inputs: Register_Onboarding_Personal_Info_Save_And_Next_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angaben speichern & Weiter`)
};

/**
* | output |
* | --- |
* | "Save details & Next" |
*
* @param {Register_Onboarding_Personal_Info_Save_And_Next_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_save_and_next_button = /** @type {((inputs?: Register_Onboarding_Personal_Info_Save_And_Next_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Save_And_Next_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_save_and_next_button(inputs)
	return en_register_onboarding_personal_info_save_and_next_button(inputs)
});